export default __webpack_public_path__ + "locales/cs/WebPlugins.json?hash=18aa8e1767838c4e8b480e991a329f6a";